import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiX } from 'react-icons/fi';

const EditPaymentForm = ({ payment, onSuccess, onCancel }) => {
    const [formData, setFormData] = useState({
        paymentAmount: payment.paymentAmount,
        paymentDate: new Date(payment.paymentDate).toISOString().split('T')[0],
        renewalDate: payment.renewalDate ? new Date(payment.renewalDate).toISOString().split('T')[0] : '',
        paymentRemarks: payment.paymentRemarks || ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const token = localStorage.getItem('token');
            const payload = { ...formData };
            if (payment.paymentType === 'misc_fees') {
                delete payload.renewalDate;
            }
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/api/payments/${payment._id}`,
                payload,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'ngrok-skip-browser-warning': 'true'
                    }
                }
            );

            if (response.data.success) {
                onSuccess(response.data.data);
            }
        } catch (err) {
            setError(err.response?.data?.error || err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full">
            <div className="relative top-20 mx-auto p-5 border w-[600px] shadow-lg rounded-md bg-white">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-medium">Edit Payment</h3>
                    <button onClick={onCancel} className="text-gray-500 hover:text-gray-700">
                        <FiX />
                    </button>
                </div>

                {error && (
                    <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-md">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Payment Type</label>
                        <div className="mt-1 block w-full rounded-md border border-gray-300 bg-gray-50 px-3 py-2">
                            {payment.paymentType === 'misc_fees' ? 'Misc Fees' : payment.paymentType}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            {payment.godMember ? 'Member' : 'Group'}
                        </label>
                        <div className="mt-1 block w-full rounded-md border border-gray-300 bg-gray-50 px-3 py-2">
                            {payment.godMember ? (
                                payment.godMember.fullName
                            ) : (
                                <div>
                                    {payment.godGroup.groupName}
                                    {payment.godGroup.renewalDate && (
                                        <span className="ml-2">
                                            - Renewal Date: <span className="text-red-600">
                                                {new Date(payment.godGroup.renewalDate).toLocaleDateString()}
                                            </span>
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">Amount</label>
                        <div className="mt-1 relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <span className="text-gray-500 sm:text-sm">$</span>
                            </div>
                            <input
                                type="number"
                                name="paymentAmount"
                                value={formData.paymentAmount}
                                onChange={handleChange}
                                className="block w-full pl-7 pr-12 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                placeholder="0.00"
                                required
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">Payment Date</label>
                        <input
                            type="date"
                            name="paymentDate"
                            value={formData.paymentDate}
                            onChange={handleChange}
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                            required
                        />
                    </div>

                    {payment.paymentType !== 'misc_fees' && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Renewal Date</label>
                        <input
                            type="date"
                            name="renewalDate"
                            value={formData.renewalDate}
                            onChange={handleChange}
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                            required
                        />
                    </div>
                    )}

                    <div>
                        <label className="block text-sm font-medium text-gray-700">Remarks</label>
                        <textarea
                            name="paymentRemarks"
                            value={formData.paymentRemarks}
                            onChange={handleChange}
                            rows="3"
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                            placeholder="Add any remarks here..."
                        />
                    </div>

                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                        >
                            {loading ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditPaymentForm; 